"use strict";
/**
 * Menú Sessió
 * Component: AppSessionMenú.tsx
 * Llenguatge: TypeScrypt
 * Autors:
 * Versió: 1.1
 * Data: 21/05/2020
 * (c) Ajuntament de Manresa - nov 2018 - Departament de Sistemes d'Informació
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var core_1 = require("@material-ui/core");

var PowerSettingsNew_1 = require("@material-ui/icons/PowerSettingsNew");

var HelpOutline_1 = require("@material-ui/icons/HelpOutline");

var AppMenuSeparator_1 = require("./AppMenuSeparator");

var AppSessionMenu = function AppSessionMenu(props) {
  return React.createElement(core_1.Menu, {
    anchorEl: props.anchorEl,
    anchorReference: "anchorEl",
    anchorOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    transformOrigin: {
      vertical: 'top',
      horizontal: 'right'
    },
    open: props.open,
    onClose: props.onClose,
    style: {
      zIndex: 2000
    }
  }, React.createElement(core_1.MenuItem, null, React.createElement(core_1.ListItemText, {
    primary: props.treballador.nomiCognoms,
    secondary: props.treballador.llocDesc
  })), React.createElement(AppMenuSeparator_1.default, null), !!props.onHelp && React.createElement(core_1.MenuItem, {
    button: true,
    onClick: props.onHelp
  }, React.createElement(core_1.ListItemIcon, null, React.createElement(HelpOutline_1.default, {
    fontSize: "small"
  })), React.createElement(core_1.ListItemText, {
    primary: "Ajuda"
  })), React.createElement(core_1.MenuItem, {
    button: true,
    onClick: props.onDisconnect
  }, React.createElement(core_1.ListItemIcon, null, React.createElement(PowerSettingsNew_1.default, {
    fontSize: "small"
  })), React.createElement(core_1.ListItemText, {
    primary: "Desconnectar"
  })));
};

exports.default = AppSessionMenu;